import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import GalleryInput from '../../../../../components/form/GalleryInput'
import { usePdfOptionsFormActions } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import { useDocumentHeader, useDocumentHeaderValue } from '../../general/documentHeader/_load/DocumentHeaderLoader'
import { useSaveDocumentHeader } from '../../general/documentHeader/_requests/saveDocumentHeader'
import { useRemoveDocumentHeader } from '../../general/documentHeader/_requests/removeDocumentHeader'
import ListItemWrapper from '../../../../../components/list/ListItemWrapper'
import DropdownListItem from '../../../../../components/list/DropdownListItem'
import { useSessionPermission } from '@btime/react-session'

const HeaderContent = () => {
  const { t: tSO } = useTranslation('serviceOrders')
  const { t: tComponents } = useTranslation('components')

  const sizes = {
    verySmall: tComponents('pdf.options.size.verySmall'),
    small: tComponents('pdf.options.size.small'),
    medium: tComponents('pdf.options.size.medium'),
    large: tComponents('pdf.options.size.large'),
    veryLarge: tComponents('pdf.options.size.veryLarge'),
    giant: tComponents('pdf.options.size.giant')
  }

  const OPTIONS = [
    { label: tComponents('pdf.options.sizeWithPx', { size: sizes.verySmall, px: 50 }), value: '50px' },
    { label: tComponents('pdf.options.sizeWithPx', { size: sizes.small, px: 80 }), value: '80px' },
    { label: tComponents('pdf.options.sizeWithPx', { size: sizes.medium, px: 90 }), value: '90px' },
    { label: tComponents('pdf.options.sizeWithPx', { size: sizes.large, px: 100 }), value: '100px' },
    { label: tComponents('pdf.options.sizeWithPx', { size: sizes.veryLarge, px: 150 }), value: '150px' },
    { label: tComponents('pdf.options.sizeWithPx', { size: sizes.giant, px: 180 }), value: '180px' }
  ]

  const { handleChange } = usePdfOptionsFormActions()
  const [saveImage, { loading: loadingImage }] = useSaveDocumentHeader()
  const [removeImage, { loading: removingImage }] = useRemoveDocumentHeader()
  const documentHeaderValue = useDocumentHeaderValue()
  const documentHeader = useDocumentHeader()
  const [imageHeight, setImageHeight] = useState(
    (documentHeaderValue && documentHeaderValue[0]?.height) || OPTIONS[0].value
  )
  const hasResumePdfHeaderImagePermission = useSessionPermission('useResumePdfHeaderImage')

  useEffect(() => {
    handleChange('headerImage', documentHeaderValue)
  }, [documentHeaderValue])

  const handleChangeHeight = selectedOption => {
    setImageHeight(selectedOption)
    save(documentHeaderValue, selectedOption)
  }

  const handleChangeImage = image => {
    if (!image?.length) {
      removeImage(documentHeader.id)
      return
    }
    save(image, imageHeight)
  }

  const save = (image, imageHeight) => {
    image[0].height = imageHeight
    handleChange('headerImage', image)
    saveImage({ ...documentHeader, value: image })
  }

  return hasResumePdfHeaderImagePermission ? (
    <>
      <ListItemWrapper bgColor={'transparent'}>
        <Text>{tSO('pdf.options.headerImageTitle')}</Text>
        <GalleryInput
          multiple={false}
          limit={1}
          colWidth="80%"
          thumbHeight="6rem"
          value={documentHeaderValue}
          onChange={handleChangeImage}
          buttonLabel={tSO('pdf.options.add')}
          buttonHeight="4rem"
          isLoading={loadingImage || removingImage}
          accept={'image/*'}
          gap={0.3}
        />
      </ListItemWrapper>
      {documentHeaderValue && (
        <DropdownListItem
          bottomDistance={'10px'}
          onChange={handleChangeHeight}
          label={tSO('pdf.options.headerImageHeight')}
          value={imageHeight}
          options={OPTIONS}
          invert
        />
      )}
    </>
  ) : (
    <></>
  )
}

export default HeaderContent
